import MathTagFactory from './MathTag'
import MathToolbar from './MathToolbar'

module.exports = (modules)->
  {React,Icon,textedit_utils,CollapsePanel,reducers,SharedReducers,slate} = modules
  MathTag = MathTagFactory(modules)
     
  # what name to use, should be unique
  name:"Math"

  tags:{"duomath"}

  # html to insert from drag and drop
  drophtml:'<duo-math value="E=mc^2"></duo-math>'
  
  # What to render in the toolbar when element is selected
  toolbar:MathToolbar(modules)
  
  # what icon to show in media elements
  icon:(props)-> 
  icon:(props)-> 
    <React.Fragment>
      <div style={{border:"1px solid rgba(255.255.255.0.1)",width:48,height:35,margin:"0 auto",position:"relative"}}>
        <svg width="2.5em" height="2.5em" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <g style={{fill:"currentColor"}}>
          <path d="m89.688 3.2812h-32.969-4.6875c-2.1875 0-3.2812 1.7188-3.2812 3.4375-1.5625 8.75-3.125 17.656-4.6875 26.406-2.5 13.75-4.8438 27.656-7.3438 41.406-2.5-5.4688-5.1562-10.938-7.5-16.562-0.625-1.25-1.0938-2.5-1.7188-3.75-0.625-1.0938-1.875-1.7188-3.125-1.7188h-0.46875-13.438-1.875c-1.7188 0-3.5938 1.5625-3.4375 3.4375s1.5625 3.4375 3.4375 3.4375h13.438 0.3125c3.75 8.125 7.5 16.25 11.25 24.375 0.625 1.25 1.0938 2.5 1.7188 3.75 0.46875 0.625 0.9375 1.25 1.7188 1.5625 0.15625 0 0.15625 0.15625 0.3125 0.15625 0.46875 0.15625 0.78125 0.15625 1.4062 0 0.46875 0 0.9375-0.15625 1.25-0.46875 0.15625 0 0.15625-0.15625 0.3125-0.15625 0.625-0.46875 1.25-1.0938 1.4062-1.875 1.5625-8.75 3.125-17.656 4.6875-26.562l7.5-42.188 1.4062-7.9688h29.844 4.6875c4.2188 0.15625 4.2188-6.7188-0.15625-6.7188z"/>
          <path d="m84.844 38.281c1.0938-1.25 1.25-3.125 0-4.375-1.0938-1.0938-3.2812-1.25-4.375 0-2.8125 3.4375-5.625 6.875-8.5938 10.156-2.0312-2.3438-3.9062-4.6875-5.9375-7.0312-0.9375-1.0938-1.7188-2.0312-2.6562-3.125-1.0938-1.25-3.2812-1.0938-4.375 0-1.25 1.25-1.0938 3.125 0 4.375 2.9688 3.5938 5.9375 7.0312 8.9062 10.625-2.0312 2.3438-4.0625 4.8438-6.0938 7.1875-0.9375 1.0938-1.7188 2.0312-2.6562 3.125-1.0938 1.25-1.25 3.125 0 4.375 1.0938 1.0938 3.2812 1.25 4.375 0 2.8125-3.2812 5.4688-6.5625 8.2812-9.8438 1.875 2.1875 3.75 4.5312 5.625 6.7188 0.9375 1.0938 1.7188 2.0312 2.6562 3.125 1.0938 1.25 3.2812 1.0938 4.375 0 1.25-1.25 1.0938-3.125 0-4.375-2.8125-3.4375-5.7812-6.875-8.5938-10.312 2.0312-2.5 4.2188-5 6.25-7.5 1.0938-1.0938 1.875-2.1875 2.8125-3.125z"/>
        </g>
        </svg>
      </div>
      <span className="label">Maths Tool</span>
    </React.Fragment>

  plugins:[{ 
    schema:
      blocks:
        duomath:
          isVoid: true
  }]
  
  # convert AST to HTML
  serialize:(object, children)->
    if object.type == "duomath"
      return <duo-math
        size={object.data.get("size")} 
        align={object.data.get("align")} 
        value={object.data.get("value")} 
      ></duo-math>

  # convert HTML to AST
  deserialize:(el,next)->
    return if el.tagName.toLowerCase()!="duo-math"
    attributes = textedit_utils.attributesFromElement(el)
    {
      object: 'block',
      type: "duomath",
      isVoid: true,
      data: {...attributes}
    }
  
  # convert AST to inpage editing component
  renderNode:({attributes, children, node, isSelected, editor} )->
    return if node.type!="duomath"
    attributes.style = {} if !attributes.style
    attributes = Object.assign({},attributes,{className:node.data.toObject().className})
    props = node.data.toObject()
    <MathTag attributes={attributes} props={props} node={node} isSelected={isSelected} editor={editor} name={@name}></MathTag>

